/**
 * VueLayers
 * Web map Vue components with the power of OpenLayers
 *
 * @package vuelayers
 * @author Vladimir Vershinin <ghettovoice@gmail.com>
 * @version 0.11.37
 * @license MIT
 * @copyright (c) 2017-2021, Vladimir Vershinin <ghettovoice@gmail.com>
 */
import Source from 'ol/source/Source';
import uuid from 'uuid/v4';
import Vue from 'vue';

function getSourceId(source) {
  if (source instanceof Vue) {
    return source.id;
  } else if (source instanceof Source) {
    return source.get('id');
  }

  throw new Error('Illegal source argument');
}
function setSourceId(source, sourceId) {
  if (source instanceof Vue) {
    source.id = sourceId;
    return source;
  } else if (source instanceof Source) {
    source.set('id', sourceId);
    return source;
  }

  throw new Error('Illegal source argument');
}
function initializeSource(source, defaultSourceId) {
  if (getSourceId(source) == null) {
    setSourceId(source, defaultSourceId || uuid());
  }

  return source;
}

export { getSourceId, setSourceId, initializeSource };
